// extracted by mini-css-extract-plugin
export var $animation_name = "ChristmasHeader-module--$animation_name--2af2a";
export var Frame = "ChristmasHeader-module--Frame--5ab17";
export var Frame__one = "ChristmasHeader-module--Frame__one--791ab";
export var Frame__one___loaded = "ChristmasHeader-module--Frame__one___loaded--843af";
export var Frame__three = "ChristmasHeader-module--Frame__three--c2645";
export var Frame__three___loaded = "ChristmasHeader-module--Frame__three___loaded--471ad";
export var Frame__two = "ChristmasHeader-module--Frame__two--32c29";
export var Frame__two___loaded = "ChristmasHeader-module--Frame__two___loaded--8a341";
export var Header = "ChristmasHeader-module--Header--e7281";